import React, { useEffect, useState } from "react";
import {
  Typography,
  CircularProgress,
  Card,
  CardContent,
  Button,
  Grid,
  Backdrop,
  Box,
} from "@mui/material";
import Layout from "../components/Layout";
import { getAllCourses } from "../service/service"; // Import the service function
import { useNavigate } from "react-router-dom";

const ReviewAIFeedbacks = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchCourses = async () => {
      setLoading(true); // Start loading
      try {
        const data = await getAllCourses(); // Call the service function
        console.log("data", data);
        setCourses(data.data); // Set courses in state
      } catch (error) {
        console.error("Failed to fetch courses:", error);
      } finally {
        setLoading(false); // Stop loading
      }
    };

    fetchCourses(); // Fetch courses when the component mounts
  }, []);

  const handleViewAIFeedbacks = (id, name) => {
    navigate(`/ai-feedbacks/${id}/${name}`); // Navigate to AI feedbacks table
  };

  return (
    <Layout>
      {loading ? ( // Show loading indicator
        <Backdrop open={loading} sx={{ zIndex: 1 }}>
          <CircularProgress />
        </Backdrop>
      ) : (
        <>
          <Box sx={{ mb: 3 }}>
            <Typography variant="h4">AI feedback</Typography>
            <Typography color="text.secondary">
              Choose a course to audit AI-generated feedback.
            </Typography>
          </Box>
          <Grid container spacing={2.5}>
            {courses.map((course) => (
              <Grid item xs={12} sm={6} md={4} key={course.id}>
                {" "}
                {/* Adjust the key according to your data structure */}
                <Card sx={{ height: "100%" }}>
                  <CardContent
                    sx={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Typography variant="h6">{course.name}</Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ mt: 0.75 }}
                    >
                      {course.description}
                    </Typography>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() =>
                        handleViewAIFeedbacks(course._id, course.name)
                      }
                      sx={{ mt: 2, alignSelf: "flex-start" }}
                    >
                      View AI Feedbacks
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </>
      )}
    </Layout>
  );
};

export default ReviewAIFeedbacks;
